"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalForageTaskQueue = void 0;
class LocalForageTaskQueue {
    constructor(store) {
        this.store = store;
    }
    addTask(task) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.store.setItem(task.id, task);
        });
    }
    getNextTask(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const ids = yield this.store.keys();
            if (ids.length === 0) {
                return null;
            }
            if (options && options.blacklist) {
                const filteredIds = ids.filter(id => !options.blacklist.has(id));
                if (filteredIds.length === 0) {
                    return null;
                }
                return this.store.getItem(filteredIds[0]);
            }
            const key = ids[0];
            return this.store.getItem(key);
        });
    }
    updateTask(task) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.store.setItem(task.id, task);
        });
    }
    completeTask(taskId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.store.removeItem(taskId);
        });
    }
}
exports.LocalForageTaskQueue = LocalForageTaskQueue;
